/*
 * @Description:
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  表单设计: 'Form Design',
  表单配置: 'Form configuration',
  表单发布: 'Form publishing',
  '对象名称：': 'Object Name:',
  基础字段: 'Basic Fields',
  高级字段: 'Advanced Fields',
  回收站: 'Recycle bin',
  整行: 'the whole line',
  单列: 'single-row',
  两列: 'Two columns',
  三列: 'Three columns',
  '1/2行': '1/2 line',
  '1/3行': '1/3 line',
  '2/3行': '2/3 line',
  字段清单: 'Field List',
  字段属性: 'Field attributes',
  字段设置: 'Field set',
  表单属性: 'Form properties',
  表单设置: 'Form set',
  请点击选中字段进行字段属性设置: 'Please click on the selected field to set its properties',
  '子表单数量超出限额！': 'The number of sub forms exceeds the limit!',
  表单设计未保存: 'The form design has not been saved',
  不保存: 'Do not save',
  '是否需要保存本次表单设计内容，并继续跳转页面？': 'Do you need to save the design content of this form and continue to jump to the page?',
  留在当前页面: 'Stay on the current page',
  保存并关闭: 'Save and Close',
  '当前字段设置内容未确定，是否要继续跳转页面？': 'The current field settings are uncertain. Do you want to continue jumping to the page?',

  配置异常字段确认: 'Confirmation of abnormal configuration fields',
  '表单设计页存在配置异常字段，请确认是否要继续跳转，跳转后新增的配置异常字段将会移入回收站、新创建的组件将会被彻底删除。': 'The form design page contains configuration exception fields. Please confirm whether to continue to jump, and the newly added configuration exception fields will be moved to the recycle bin, and the newly created associated object table components will be deleted completely.',
  继续跳转: 'Continue to jump',
  '存在字段配置异常，请检查！': 'There are abnormal field configurations. Please check!',
  '请输入对象名称！': 'Please enter the object name!',
  请在子表单中至少添加一个自定义字段: 'Please add at least one custom field in the sub-form',
  '格式不正确,请以http:// 或 https:// 开头,且不能包含汉字': 'The format is incorrect. Please start with http:// or https:// and cannot contain Chinese characters.',
  '此项配置有误，请检查字段属性': 'There is an error in this configuration. Please check the field attributes.',
  '该字段删除后将放入回收站，请确认是否要删除？': 'After deleting this field, it will be put into the recycle bin. Please confirm whether you want to delete it?',
  '该字段删除后无法被恢复，请确认是否要删除？': 'Once this field is deleted, it cannot be restored. Please confirm whether you want to delete it?',
  从左侧拖拽添加字段: 'Drag and add fields from the left',
  '子表单中至少保留一个自定义字段！': 'At least one custom field should be retained in the sub-form!',
  异常: 'Abnormal',
  '请配置关联对象、关联主键': 'Please configure the associated object and the associated primary key',
  批量操作: 'Batch operation',
  允许查找关联新增数据: 'Allow to search for associated new data',
  '在添加订单明细时，可以设置为从关联产品字段添加明细。设置后，您可以直接一次选择多个产品，并为每个产品都添加一行订单明细': 'In the process of adding order details, you can set it to add details from the associated product field. After setting, you can directly select multiple products at once and add a line of order details for each product.',
  是否允许重复规则: 'Is it allowed to have duplicate rules?',
  '此项内容已存在，不允许重复创建': 'This item of content already exists and cannot be created repeatedly',
  '该查找关联(单选)字段为允许查找关联批量新增数据已配置字段，不可删除': 'This single-choice lookup association field is configured to allow batch addition of new data. It cannot be deleted.',
  '允许查找关联批量新增数据中配置的字段，会默认在表格字段设置中勾选': 'Allow to search for associated new data fields configured in the batch addition of new data will be checked by default in the table field settings.'
};
